// src/modules/branches/api.js
import API from '../../services/api';

// Fetch all branches with search and pagination support
export const fetchBranches = async ({ search = '', page = 1, limit = 10 }) => {
  try {
    const response = await API.get('/branches', {
      params: {
        search,
        page,
        limit
      },
    });
    return response.data;  // Return the response data
  } catch (error) {
    console.error('Error fetching branches:', error);
    throw error;
  }
};

// Create a new branch
export const createBranch = async (branchData) => {
  try {
    const response = await API.post('/branches', branchData);
    return response.data;  // Return the newly created branch data
  } catch (error) {
    console.error('Error creating branch:', error);
    throw error;
  }
};

// Get a branch by ID
export const fetchBranchById = async (branchId) => {
  try {
    const id = branchId?._id || branchId?.id || branchId;
    const response = await API.get(`/branches/${id}`);
    return response.data;  // Return the branch data
  } catch (error) {
    console.error('Error fetching branch by ID:', error);
    throw error;
  }
};

// Update a branch
export const updateBranch = async (branchId, branchData) => {
  try {
    const id = branchId?._id || branchId?.id || branchId;
    const response = await API.put(`/branches/${id}`, branchData);
    return response.data;  // Return the updated branch data
  } catch (error) {
    console.error('Error updating branch:', error);
    throw error;
  }
};

// Delete a branch
export const deleteBranch = async (branchId) => {
  try {
    const id = branchId?._id || branchId?.id || branchId;
    const response = await API.delete(`/branches/${id}`);
    return response.data;  // Return the response
  } catch (error) {
    console.error('Error deleting branch:', error);
    throw error;
  }
};

// Get all users for manager dropdown
export const fetchUsers = async ({ search = '', page = 1, limit = 50 }) => {
  try {
    const response = await API.get('/users', {
      params: {
        search,
        page,
        limit
      },
    });
    return response.data;  // Return the response data
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

// Get existing branch codes for validation
export const fetchExistingBranchCodes = async () => {
  try {
    const response = await API.get('/branches/codes');
    return response.data;  // Return the response data
  } catch (error) {
    console.error('Error fetching branch codes:', error);
    throw error;
  }
};

// Get users by branch
export const fetchUsersByBranch = async (branchId) => {
  try {
    const id = branchId?._id || branchId?.id || branchId;
    const response = await API.get(`/branches/${id}/users`);
    return response.data;  // Return the response data
  } catch (error) {
    console.error('Error fetching users by branch:', error);
    throw error;
  }
};
